import React from 'react';
import styles from './styles.module.scss'
import moment from 'moment';

const RegulamentoCard = ({ regulamento }) => {

    return (
        <div className={styles.wrapper}>
            <div className={styles.bodyCard}>
                <div className={styles.title}>
                    Data e hora
                </div>
                <div className={styles.info}>
                    { `${new moment(regulamento.dataCadastro).format('DD/MM/YYYY HH:mm')}` }
                </div>
                <div className={styles.title}>
                    Importado por:
                </div>
                <div className={styles.info}>
                    {regulamento.nomeUsuarioCadastro}
                </div>
                <div className={styles.title}>
                    Tipo:
                </div>
                <div className={styles.info}>
                    {"Regulamento"}
                </div>
                
                <div className={styles.title}>
                    Arquivo:
                </div>
                <div className={styles.info}>
                    {regulamento.titulo}
                </div>
            </div>

            <div className={styles.actionWrapper}>

                <div className={styles.andamento}>IMPORTADO COM SUCESSO</div>

            </div>

        </div>
    )
}

export default RegulamentoCard;